// extracted by mini-css-extract-plugin
export default {"content":"CohostForm_content__fdUS9"};